// Local translations
export const T = {
  en_GB: {
    displayOptions: "Display Options",
    displayDesc: "Choose how to display the expected value projection",
    showChart: "Show Chart",
    showLineChart: "Display the line chart visualization",
    showSummaryTable: "Show Summary Table",
    summaryTableDesc: "Yearly summary with deposits, returns, and value",
    showYearlyTable: "Show Yearly Table",
    yearlyTableDesc: "Monthly breakdown for each year",
    atLeastOneOption: "At least one display option must be selected",
  },
  nb_NO: {
    displayOptions: "Visningsalternativer",
    displayDesc: "Velg hvordan forventet verdi-projeksjonen skal vises",
    showChart: "Vis diagram",
    showLineChart: "Vis linjediagramvisualisering",
    showSummaryTable: "Vis sammendragstabell",
    summaryTableDesc: "Årlig sammendrag med innskudd, avkastning og verdi",
    showYearlyTable: "Vis årstabell",
    yearlyTableDesc: "Månedlig fordeling for hvert år",
    atLeastOneOption: "Minst ett visningsalternativ må velges",
  },
} as const;
